/**
 * Spinner — used wherever the app is waiting on async data.
 *
 * Two variants:
 *   <Spinner />            — inline, 24 px, used inside content areas
 *   <Spinner page />       — centred in the full view area, used as a page-level gate
 *                            while session or route data is loading
 */
export function Spinner({ page = false }: { page?: boolean }) {
  return (
    <div class={page ? 'spinner-page' : 'spinner-inline'} aria-label="Loading" role="status">
      <svg
        class="spinner"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <circle
          cx="12"
          cy="12"
          r="9"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-dasharray="42 14"
        />
      </svg>
    </div>
  );
}
